// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3CStH","box":"WorkspacesBox_box__2lmaG","node":"WorkspacesBox_node__2bRbl"};